import { MovieSettingsOutlineIcon } from './MovieSettingsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id D90C8E93-5B99-4604-A597-5DA45FC3CEB2
 * name movie-settings-outline
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-settings-outline.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const FilmSettingsOutlineIcon = MovieSettingsOutlineIcon;
export default FilmSettingsOutlineIcon